import { adminHttpClient } from '../../../commons/adminHttpClient'
import { InviteEmployeesFormValues } from '../../tasks/inviteEmployees'

const invitePerksEmployees = (values: InviteEmployeesFormValues): Promise<void> => {
  return adminHttpClient.put('/AdminDashboard/ManagePeople/Perks/InviteEmployees', values)
}

export default invitePerksEmployees
